module.exports = __webpack_public_path__ + "fonts/Poppins-Bold.dd24d10.woff2";